import React from 'react';

interface ErrorState {
  error: Error;
  errorInfo: React.ErrorInfo;
  hasError: boolean;
}

interface ErrorProps {
  children: React.ReactNode;
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null, hasError: false };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({
      error,
      errorInfo,
      hasError: true,
    });
  }

  render() {
    const _state = this.state as ErrorState;
    if (_state.hasError) {
      return (
        <div style={{
          padding: '4rem',
        }}>
          Something went wrong.
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {_state.error && _state.error.toString()}
            <br />
            {_state.errorInfo && _state.errorInfo.componentStack}
          </details>
        </div>
      );
    }
  
    return (this.props as ErrorProps).children;
  }
}
